export enum Type {
  NAVIGATE = 'NAVIGATE',
}

export interface NavigateAction {
  type: Type.NAVIGATE;
  href: string;
}

interface NavigateRequest {
  href: string;
}

export const navigate = ({ href }: NavigateRequest): NavigateAction => {
  return {
    type: Type.NAVIGATE,
    href,
  };
};
